import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { campaignQueryKeys } from "./queryKeys"
import { useCampaignQuery } from "./useCampaignQuery"

export function useCampaignProject() {
    const { selectedNetwork } = useNetworksStateContext()
    const url = `projects/${selectedNetwork.slug}/`
    const queryKey = campaignQueryKeys["project"]()

    return useCampaignQuery(
        url,
        queryKey,
        {},
        { enabled: true },
    )
}